import { VoucherCreatePage } from '@/features/voucher/pages/VoucherCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherCreatePage,
})
